module.exports = __webpack_public_path__ + "static/media/washing_machine.4192692c.svg";